import Vue from 'vue'
import routes from 'src/routes'
import store from 'src/store'
import * as filters from 'src/filters'
import App from './App.vue'

// plugins
import VueRouter from 'vue-router'
import VueNotify from 'vue-notifyjs'
import validations from 'src/validations'
import globalComponents from 'src/globalComponents'

// libraries
import 'vue-notifyjs/themes/default.css'
import 'src/assets/sass/app.scss'
import 'src/assets/sass/vue-notifyjs.scss'

Vue.config.productionTip = false

// plugin setup
Vue.use(VueRouter)
Vue.use(VueNotify)
Vue.use(validations)
Vue.use(globalComponents)

// register filters
Object.keys(filters).forEach(k => {
  Vue.filter(k, filters[k])
})

// configure router
const router = new VueRouter({
  mode: 'history',
  routes,
  linkActiveClass: 'active',
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash }
    } else {
      return { x: 0, y: 0 }
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
